export default {
  talk_to_us: 'Parlez-nous :',
  send_us_email: 'Envoyez-nous un e-mail :',
  visit_website: 'Visitez notre site web :',
  join_our_community: 'Rejoignez notre communauté pour des offres exclusives et des actualités !',
};
